module.exports = __webpack_public_path__ + "static/img/bg-ar.c7d6f4c4.png";